module.exports = __webpack_public_path__ + "static/img/l2.452765f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/l2.png
// module id = qW3D
// module chunks = 1